import React, { memo, useRef, useEffect } from 'react';
import ReactECharts from 'echarts-for-react';
import { useTranslation } from 'react-i18next';

import { formatNumberToB, formatNumberToB_N1 } from '../../helpers/utils';

export default memo(function IDXValueScaleChart(props) {
    const { tradedValueUp, tradedValueDown, tradedValueNoChange } = props;
    
    //
    const { t } = useTranslation();
    //
    const refChart = useRef(null);
    //
    const _getChartOptions = () => {
        const _cats = [t("tang"), t("giam"), t("khongDoi")];
        const _datas = [tradedValueUp, tradedValueDown, tradedValueNoChange];
        //
        return {
            useUTC: false,
            textStyle: {
                fontFamily: "tahoma, 'Be Vietnam Pro'",
            },
            tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "shadow",
                },
                textStyle: {
                    // lineHeight: 30,
                    color: '#fff',
                    fontSize: 12,
                    lineHeight: '21px'
                }, 
                padding: [5, 9],
                backgroundColor: 'rgba(47, 62, 76, 0.9)', 
                borderColor: 'transparent',
                confine: true,
                formatter: function (params) {
                    var colorSpan = color => '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' + color + '"></span>';
                    let rez = '<p>' + params[0].axisValue + '</p>';
                    params.forEach(item => {
                        var xx = '<p>'   + colorSpan(item.color) + '<b>' + formatNumberToB(item.data) + " " + t("ty") + '</b></p>'
                        rez += xx;
                    });
                    return rez;
                },
            },
            visualMap: {
                show: false,
                orient: 'horizontal',
                seriesIndex: 0,
                dimension: 0,
                pieces: [
                    { min: 0, max: 0, color: '#00E500' },
                    { min: 1, max: 1, color: '#DB3624' },
                    { min: 2, max: 2, color: '#FFD500' },
                ], 
                outOfRange: {
                    color: '#42556C'
                }
            },
            xAxis: {
                type: 'category',
                data: _cats,
                axisLabel: { color: '#D6D8DA', },
                splitLine: {
                    lineStyle: {
                        color: '#666',
                    },
                },
            },
            yAxis: [
                {
                    // name: "Value",
                    type: 'value',
                    onZero: true,
                    axisLabel : {
                        // show: false,
                        color: '#fff',
                        formatter: function(value) {
                            return formatNumberToB_N1(value) + " " + t("ty");
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#666',
                            type: 'dotted',
                        },
                    },
                    // max: function(value) {
                    //     return value.max * 1.2;
                    // },
                }
            ],
            series: [
                {
                    yAxisIndex: 0,
                    data: _datas,
                    type: 'bar',
                    label: {
                        show: true,
                        position: 'top',
                        color: '#fff',
                        formatter: function(params) {
                            return formatNumberToB(params.data) + " " + t("ty")
                        }
                    },
                    barMaxWidth: 30,
                },
            ],
            grid: {
                left: "10px",
                right: "10px",
                top: "30px",
                bottom: "10px",
                containLabel: true,
            },
        }
    }
    //
    useEffect(() => {
        if(refChart && refChart.current)
        {
            refChart.current.getEchartsInstance().setOption(_getChartOptions());
        }
    });
    //
    return (
        <>
            {
                tradedValueUp > 0 || tradedValueDown > 0 || tradedValueNoChange > 0 ? (
                    <ReactECharts style={{width: '100%', height: '100%', ...props.style}}
                        ref={refChart}
                        lazyUpdate={true}
                        option={_getChartOptions()}
                    />
                ) :<></>
            }
        </>
    )
}, (prevProps, nextProps) => {
    if (prevProps.tradedValueUp === nextProps.tradedValueUp
        && prevProps.tradedValueDown === nextProps.tradedValueDown
        && prevProps.tradedValueNoChange === nextProps.tradedValueNoChange) {
        return true;
    }
    return false;
})

